// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/warehouse",
    element: lazy(() => import("../pages/ManageWarehouse/index.js")),
  },
];

export default routes;
